/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OpenDynamicLinkAutoOpenTrigger {
    InboundCallOffered = 1,
    InboundCallAnswered = 2,
    InboundAnsweredCallIdle = 3,
    OutboundCallDialed = 5,
    OutboundCallConnected = 6,
    OutboundConnectedCallIdle = 7,
}
